import { combineReducers } from 'redux'

import resultados from './experienciaProfissional'

export default combineReducers({ resultados })
